import interceptor from '@/plugins/interceptor';
const pathController = '/Spot'

export default {
  state: () => ({
    spots: []
  }),
  getters: {
    spots_spots: state => state.spots,
  },
  mutations: { 
    spots_setSpots(state, value) {
      state.spots = value;
    },
    spots_updateSpots(state, model) {
      const idx = state.spots.findIndex(p => p.id == model.id);
      state.spots[idx] = model;
    },
    spots_deleteSpots(state, id) {
      const idx = state.spots.findIndex(p => p.id == id);
      state.spots.splice(idx, 1);
    }
  },
  actions: {
    async spots_setSpots({ commit }, list) {
      commit('spots_setSpots', list);
    },
    async spots_search({ dispatch }, params) {
      try {
        const request = await interceptor.authenticate.get(`${process.env.VUE_APP_API_URL}${pathController}/search?${params}`);
        return request.data;
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.message}`, title: window.vueApp.$t('left_menu.spot_programming.spot'), error: true});
        throw new Error(error);
      }
    },
    async spots_searchNew({ dispatch }, model) {
      try {
        const request = await interceptor.authenticate.post(`${process.env.VUE_APP_API_URL}${pathController}/searchNew`, model);
        return request.data;
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.message}`, title: window.vueApp.$t('left_menu.spot_programming.spot'), error: true});
        throw new Error(error);
      }
    },
    async spots_search4Certify({dispatch}, model) {
      try {
        const request = await interceptor.authenticate.post(`${process.env.VUE_APP_API_URL}${pathController}/search4Certify`, model);
        return request.data;
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.response.data ? window.vueApp.$t(`notifications.validation.${error.response.data}`) : error.message}`, title: window.vueApp.$t('left_menu.spot_programming.spot'), error: true});
        throw new Error(error);
      }
    },
    // async spots_getAll({ commit, dispatch }) {
    //   try {
    //     const request = await interceptor.authenticate.get(`${process.env.VUE_APP_API_URL}${pathController}/getAll`);
    //     commit('spots_setSpots', request.data);
    //   } catch (error) {
    //     dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.message}`, title: window.vueApp.$t('left_menu.spot_programming.spot'), error: true});
    //     throw new Error(error);
    //   }
    // },
    async spots_getById({ dispatch }, param) {
      try {
        const request = await interceptor.authenticate.get(`${process.env.VUE_APP_API_URL}${pathController}/getById?id=${param.id}`);
        return request.data;
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.message}`, title: window.vueApp.$t('left_menu.spot_programming.spot'), error: true});
        throw new Error(error);
      }
    },
    async spots_create({ dispatch }, model) {
      try {
        const request = await interceptor.authenticate.post(`${process.env.VUE_APP_API_URL}${pathController}/create`, model);
        dispatch('notifications_create', {text: window.vueApp.$t('notifications.create'), title: window.vueApp.$t('left_menu.spot_programming.spot')});
        return request.data;
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.response.data ? window.vueApp.$t(`notifications.validation.${error.response.data}`) : error.message}`, title: window.vueApp.$t('left_menu.spot_programming.spot'), error: true});
        throw new Error(error);
      }
    },
    async spots_update({ dispatch }, model) {
      try {
        await interceptor.authenticate.post(`${process.env.VUE_APP_API_URL}${pathController}/update`, model);
        dispatch('notifications_create', {text: window.vueApp.$t('notifications.update'), title: window.vueApp.$t('left_menu.spot_programming.spot')});
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.response.data ? window.vueApp.$t(`notifications.validation.${error.response.data}`) : error.message}`, title: window.vueApp.$t('left_menu.spot_programming.spot'), error: true});
        throw new Error(error);
      }
    }, 
    async spots_saveAndTest({ dispatch }, model) {
      try {
        const request = await interceptor.authenticate.post(`${process.env.VUE_APP_API_URL}${pathController}/saveAndTest`, model);
        if (request.data == "SAVED_OK_BUT_NO_SCHEDULES") {
          dispatch('notifications_create', {text: window.vueApp.$t('notifications.validation.SAVED_OK_BUT_NO_SCHEDULES'), title: window.vueApp.$t('left_menu.spot_programming.spot')});
        } else {
          dispatch('notifications_create', {text: window.vueApp.$t('notifications.update'), title: window.vueApp.$t('left_menu.spot_programming.spot')});
        }
        return request.data;
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.response.data ? window.vueApp.$t(`notifications.validation.${error.response.data}`) : error.message}`, title: window.vueApp.$t('left_menu.spot_programming.spot'), error: true});
        throw new Error(error);
      }
    },
    async spots_createAndTest({ dispatch }, model) {
      try {
        const request = await interceptor.authenticate.post(`${process.env.VUE_APP_API_URL}${pathController}/createAndTest`, model);
        if (request.data == "SAVED_OK_BUT_NO_SCHEDULES") {
          dispatch('notifications_create', {text: window.vueApp.$t('notifications.validation.SAVED_OK_BUT_NO_SCHEDULES'), title: window.vueApp.$t('left_menu.spot_programming.spot')});
        } else {
          dispatch('notifications_create', {text: window.vueApp.$t('notifications.update'), title: window.vueApp.$t('left_menu.spot_programming.spot')});
        }
        return request.data;
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.response.data ? window.vueApp.$t(`notifications.validation.${error.response.data}`) : error.message}`, title: window.vueApp.$t('left_menu.spot_programming.spot'), error: true});
        throw new Error(error);
      }
    },
    async spots_delete({ commit, dispatch }, model) {
      try {
        await interceptor.authenticate.delete(`${process.env.VUE_APP_API_URL}${pathController}/delete?spotId=${model.id}`);
        commit('spots_deleteSpots', model.id);
        dispatch('notifications_create', {text: window.vueApp.$t('notifications.delete'), title: window.vueApp.$t('left_menu.spot_programming.spot')});
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.response.data ? window.vueApp.$t(`notifications.validation.${error.response.data}`) : error.message}`, title: window.vueApp.$t('left_menu.spot_programming.spot'), error: true});
        throw new Error(error);
      }
    },
    async spots_spotCopy({ dispatch }, model) {
      try {
        await interceptor.authenticate.post(`${process.env.VUE_APP_API_URL}${pathController}/spotCopy`, model);
        dispatch('notifications_create', {text: window.vueApp.$t('notifications.copySpot'), title: window.vueApp.$t('modal.spot_programming.spot_copy.title')});
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.response.data ? window.vueApp.$t(`notifications.validation.${error.response.data}`) : error.message}`, title: window.vueApp.$t('modal.spot_programming.spot_copy.title'), error: true});
        throw new Error(error);
      }
    },    
    async spots_cancelAndReplace({ dispatch }, model) {
      try {
        const response = await interceptor.authenticate.get(`${process.env.VUE_APP_API_URL}${pathController}/cancelAndReplace?spotId=${model.id}`);
        dispatch('notifications_create', {text: window.vueApp.$t('notifications.create'), title: window.vueApp.$t('workspace.spot_detail.cancel_replace')});
        return response.data;
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.response.data ? window.vueApp.$t(`notifications.validation.${error.response.data}`) : error.message}`, title: window.vueApp.$t('workspace.spot_detail.cancel_replace'), error: true});
        throw new Error(error);
      }
    },
  }
}

